import React from 'react'
import Tr from 'translations/Translations';
import DoneIcon from '@material-ui/icons/Done'
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconConfirmButton({
	tooltip = Tr('confirm'),
	...props
}) {
	return <WorkableIconButton
		tooltip={tooltip}
		Icon={DoneIcon}
		{...props}
	/>
}

WorkableIconConfirmButton.propTypes = {
	working: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	hideTooltip: PropTypes.bool,
	color: PropTypes.string,
	onClick: PropTypes.func
}

export default WorkableIconConfirmButton;